import DatePicker from './DatePicker';
import React from 'react';
import classNames from 'classnames';
import styles from '../Base.module.css';
import Label from '../Label';
import addStyles from './DatePeriod.module.css';
var isDatePeriod = true;
export default React.forwardRef(function DateTime(props, ref) {
    var _a, _b;
    return (React.createElement("div", { className: classNames(styles.control, (_a = {},
            _a[styles.controlTop] = props.labelType === 'top',
            _a)), ref: ref },
        props.label && (React.createElement(Label, { label: props.label, labelType: props.labelType, required: props.required })),
        React.createElement("div", { className: classNames(styles.inputContainer, (_b = {},
                _b[styles.inputContainerTop] = props.labelType === 'top',
                _b)), style: { display: 'flex', flexWrap: 'wrap' } },
            React.createElement(DatePicker, { isDatePeriod: isDatePeriod, selectedDate: props.startDate, name: "".concat(props.name, "StartDate"), onChange: props.handleStartDateChange, isValid: props.isValidStart, validationMessage: props.validationMessageStart }),
            React.createElement("div", { className: addStyles.dash }, "\u2013"),
            React.createElement(DatePicker, { isDatePeriod: isDatePeriod, selectedDate: props.endDate, name: "".concat(props.name, "EndDate"), onChange: props.handleEndDateChange, isValid: props.isValidEnd, validationMessage: props.validationMessageEnd }))));
});
